import { BaseModel } from './../../../classes/base-model';

export class UserGroup extends BaseModel {
    UserId:number;
    GroupId:number;
}



// WEBPACK FOOTER //
// ./src/app/modules/role-module/models/user-group.ts